import { useState, useCallback } from 'react'

export interface OpenFromGqlParams {
  originalQuestion: string
  suggestions: string[]
  chatSessionId: string
}

export interface UseTarotReframeModalResult {
  isOpen: boolean
  originalQuestion: string
  suggestions: string[]
  activeSuggestionIndex: number
  chatSessionId: string | null
  openFromGql: (params: OpenFromGqlParams) => void
  close: () => void
  refresh: () => void
}

export const useTarotReframeModal = (): UseTarotReframeModalResult => {
  const [isOpen, setIsOpen] = useState(false)
  const [originalQuestion, setOriginalQuestion] = useState('')
  const [suggestions, setSuggestions] = useState<string[]>([])
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(0)
  const [chatSessionId, setChatSessionId] = useState<string | null>(null)

  const openFromGql = useCallback((
    { originalQuestion: oq, suggestions: sugs, chatSessionId: sessionId }: OpenFromGqlParams,
  ) => {
    if (sugs.length === 0) return
    setSuggestions(sugs)
    setOriginalQuestion(oq)
    setChatSessionId(sessionId)
    setActiveSuggestionIndex(0)
    setIsOpen(true)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
  }, [])

  const refresh = useCallback(() => {
    if (suggestions.length === 0) return
    setActiveSuggestionIndex((current) => (current + 1) % suggestions.length)
  }, [suggestions.length])

  return {
    isOpen,
    originalQuestion,
    suggestions,
    activeSuggestionIndex,
    chatSessionId,
    openFromGql,
    close,
    refresh,
  }
}
